var angular = require('angular'),
    Parse = require('parse').Parse;

angular.module('ikeweb.user').factory('signupService', ['loginService',

    function(loginService) {

        function signup(userObj) {
            var email = userObj.email.toLowerCase();
            var password = userObj.password;

            return Parse.Cloud.run('signUpUser', {
                    username: email,
                    password: password
                })
                .then(function() {
                    return loginService.login({
                        username: email,
                        password: password
                    });
                });
        }

        return {
            signup: signup
        };
    }

]).config(['$provide',
    function($provide) {

        var functionsToDecorate = [
            'signup'
        ];

        $provide.decorator('signupService', ['$delegate', 'qPromiseDecoratorService',
            function($delegate, qPromiseDecoratorService) {
                return qPromiseDecoratorService.decorateDelegateWithPromise($delegate, functionsToDecorate);
            }
        ]);

        $provide.decorator('signupService', ['$delegate', 'parseErrorDecoratorService',
            function($delegate, parseErrorDecoratorService) {
                return parseErrorDecoratorService.decorateDelegatePromiseErrors($delegate, functionsToDecorate);
            }
        ]);

        $provide.decorator('signupService', ['$delegate', 'promiseProgressDecoratorService',
            function($delegate, promiseProgressDecoratorService) {
                return promiseProgressDecoratorService.decorateDelegateWithProgress($delegate, functionsToDecorate);
            }
        ]);

        $provide.decorator('signupService', ['$delegate', 'loggingDecorator',
            function($delegate, loggingDecorator) {
                return loggingDecorator.decorateDelegateWithLogging($delegate, functionsToDecorate);
            }
        ]);

        $provide.decorator('signupService', ['$delegate', 'decoratedPromiseBuilder', 'notificationService', 'cloudCodeErrors',
            function($delegate, decoratedPromiseBuilder, notificationService, CLOUD_ERRORS) {

                function errorIs(code) {
                    return function(error) {
                        return code === error.message;
                    };
                }

                return decoratedPromiseBuilder
                    .forDelegate($delegate)
                    .decorate('signup')
                    .onSuccess(notificationService.success('NOTIFICATION.SIGNUP.SIGN_UP', 'NOTIFICATION.SIGNUP.SIGNED_UP'))
                    .onErrorIf(errorIs(CLOUD_ERRORS.USER_EXISTS), notificationService.error('NOTIFICATION.SIGNUP.SIGN_UP', 'NOTIFICATION.SIGNUP.EMAIL_ALREADY_TAKEN'))
                    .onError(notificationService.error('NOTIFICATION.SIGNUP.SIGN_UP', 'NOTIFICATION.SIGNUP.SIGN_UP_PROBLEM'))
                    .fork();
            }
        ]);
    }
]);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/user/signup/signup.service.js
// module id = 470
// module chunks = 0